import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [key, setKey] = useState(location.pathname);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  // Track mobile device status
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // This will trigger a remount of the component whenever the location changes
  // But ONLY for non-Calendar pages or on desktop to avoid mobile performance issues
  useEffect(() => {
    // Special case for calendar page on mobile - don't force remount
    if (isMobile && location.pathname === '/calendar' && key === '/calendar') {
      // Skip remounting for the calendar page on mobile when it's already mounted
      return;
    }
    
    setKey(location.pathname);
  }, [location.pathname, isMobile]);

  return (
    <div className="page-transition" key={key}>
      {children}
    </div>
  );
};

export default PageTransition;